import React from 'react';
import img1 from '../Image/bikes/Screenshot (85).png'
import img2 from '../Image/bikes/Screenshot (86).png'
import img3 from '../Image/bikes/Screenshot (87).png'
import { ImPointRight } from 'react-icons/im';
import Footer from './Footer';

const Bikes = () => {
    return (
        <div className='text-white bg-black'>
            <div >
                <h1 className='text-center mb-12 text-5xl font-bold text-primary'>Explore More about Bikes Store</h1>
                <div class="carousel shadow-2xl mx-24 rounded-[20px] h-[500px]">
                    <div id="item1" class="carousel-item w-full">
                        <img src={img1} class="w-full" />
                    </div>
                    <div id="item2" class="carousel-item w-full">
                        <img src={img2} class="w-full" />
                    </div>
                    <div id="item3" class="carousel-item w-full">
                        <img src={img3} class="w-full" />
                    </div>


                </div>
                <div class="flex justify-center w-full py-2 gap-2">
                    <a href="#item1" class="btn btn-xs">1</a>
                    <a href="#item2" class="btn btn-xs">2</a>
                    <a href="#item3" class="btn btn-xs">3</a>
                </div>
            </div>
            <p><a className='btn bg-green-500 w-56 ml-[40%] text-center my-12' href="https://my-11th-assignment-clintsite.web.app/">Live side</a></p>
            <div className='mt-12  text-5xl font-bold'>
                <h1 className='text-center text-primary'>Details Aout Project</h1>
                <div className='mx-[25%]  mb-12'>
                    <p className='my-5 text-xl  font-bold'><ImPointRight className='text-primary'></ImPointRight>This projecst is about bike store house.
                    </p>
                    <p className='text-xl my-5 font-bold'><ImPointRight className='text-primary'></ImPointRight>There are a banner and some products on home page.
                    </p>
                    <p className='text-xl my-5 font-bold'><ImPointRight
                        className='text-primary'></ImPointRight>You can add products or remobe products from here.
                    </p>
                    <p className='text-xl my-5 font-bold'><ImPointRight
                        className='text-primary'></ImPointRight>You can't inter some pages without login.
                    </p>
                    <p className='text-xl my-5 font-bold'><ImPointRight className='text-primary'></ImPointRight>you can add quantity or dicrase quantity.
                    </p>
                </div>
            </div>
            <div>
                <h1 className='text-center text-primary text-5xl font-bold'>Technology used:</h1>
                <p className='mx-[25%] pb-12 text-xl  font-bold'><ImPointRight className='text-primary'></ImPointRight>React JS, React Router, React Firebase Hook, Bootstrap, Firebase, Node Js, MongoDB, JWT, Heroku, React-Form-Hook.</p>
            </div>
            <Footer></Footer>
        </div>
    );
};

export default Bikes;